"use client";
import { QueueType, useGenerator } from "@/app/context/GeneratorContext";
import { useGlobalContext } from "@/app/context/store";
import { IS_MAIN_SITE } from "@/components/shared/sites/sites";

export default function DisplayErrorOutOfCredits({ translations }: { translations: any }) {
  const { user } = useGlobalContext();
  const { state } = useGenerator();

  const userCanClaimDaily = (claimDate: Date | undefined) => {
    let canClaim = true;
    if (claimDate !== undefined) {
      try {
        let date = new Date(claimDate);
        const twentyFourHours = 24 * 60 * 60 * 1000;
        const now = new Date();
        if (now.getTime() - date.getTime() < twentyFourHours) {
          canClaim = false;
        }
      } catch (e: any) {
        return false;
      }
    }
    return canClaim;
  };
  return (
    <>
      {/* Not Enough Credits State*/}
      <div
        className={`px-auto flex h-[calc(100vw-32px)] w-full flex-col items-center justify-center border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] sm:h-[60vh] sm:rounded-b-xl`}
      >
        <div className="mx-5 my-auto text-center font-medium text-white sm:mx-20">
          {translations.imageLoadingState5pt1}
          {userCanClaimDaily(user.lastDailyCreditClaim) ? (
            <>
              <br />
              <br />
              <a
                className="focus-visible:ring-ring ring-offset-background my-0 inline-flex h-10 w-full transform items-center justify-center whitespace-nowrap rounded-md bg-[#FFCC18] px-4 py-2 text-sm font-black italic text-black transition duration-500 ease-in-out hover:scale-105 hover:bg-[#FF6200] hover:brightness-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
                href={translations.path + "reward-calendar"}
              >
                {translations.imageLoadingState5pt2}
              </a>
            </>
          ) : (
            <>
              <br />
              <br />
              <div className="mb-auto">{translations.imageLoadingState5pt3}</div>
            </>
          )}
        </div>
        {userCanClaimDaily(user.lastDailyCreditClaim) ? (
          <></>
        ) : (
          <div
            className={`${
              user?.membership?.level === 0 ||
              user?.membership?.level === -1 ||
              user?.membership === undefined
                ? "block"
                : "hidden"
            } mb-4 w-full px-4 text-center`}
          >
            <div className="flex w-full cursor-default select-none flex-col rounded-md border-[0.5px] border-[#3C3C3C] bg-[#2b2d31] p-4">
              <p
                className="animate-text bg-gradient-to-r from-[#FF6200] via-[#FFCC18] to-[#FFCC18]
                             bg-clip-text font-semibold 
                             uppercase  text-transparent [text-decoration:none]"
              >
                {state.currentQueueType === QueueType.Turbo
                  ? translations.getPremiumNow1
                  : translations.getPremiumNow2}
              </p>
              <a
                className="mx-auto mt-auto w-full lg:mb-auto lg:mt-auto lg:w-auto"
                target="_blank"
                rel="noopener noreferrer"
                href={translations.path + "upgrade"}
              >
                <button className="focus-visible:ring-ring ring-offset-background mb-0 mt-2 inline-flex h-10 w-full transform items-center justify-center whitespace-nowrap rounded-md bg-[#FFCC18] px-4 py-2 text-sm font-black italic text-black transition duration-500 ease-in-out [text-decoration:none] hover:scale-105 hover:bg-[#FF6200] hover:brightness-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 lg:mb-2 lg:mt-4">
                  {IS_MAIN_SITE ? translations.upgradeCCBill1Dollar : translations.upgradeSubStar}
                </button>
              </a>
            </div>
            {/* <br />
                  <br />
                  <a href={locale.path + "upgrade"} className="underline">
                    {locale.imageLoadingState4pt2}
                  </a> */}
            {/* {locale.imageLoadingState4pt3} */}
          </div>
        )}
      </div>
    </>
  );
}
